(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-lazy-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-lazy-video')) customElements.define('tb-lazy-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.generation = 0;
      this.button = this.querySelector('[data-tb-video-toggle]');
      this.button?.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        const video = this.querySelector('video');
        if (video && !video.paused) { this.userPaused = true; this.stop(); }
        else { this.userPaused = false; this.play(true); }
      }, { signal });
      document.addEventListener('visibilitychange', () => this.update(), { signal });
      this.motion.addEventListener('change', () => this.update(), { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting); this.update();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
    }
    state(playing) {
      this.button?.setAttribute('aria-pressed', String(playing));
      this.button?.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      const play = this.querySelector('[data-tb-video-play]');
      const pause = this.querySelector('[data-tb-video-pause]');
      if (play) play.hidden = playing;
      if (pause) pause.hidden = !playing;
    }
    stop() { this.generation++; this.querySelector('video')?.pause(); this.state(false); }
    update() {
      if (!this.visible || document.hidden || this.motion.matches || navigator.connection?.saveData || this.userPaused) this.stop();
      else this.play(false);
    }
    async play(manual) {
      if (!manual && (!this.visible || document.hidden || this.motion.matches || navigator.connection?.saveData || this.userPaused)) return;
      const template = this.querySelector('template');
      if (template) {
        template.replaceWith(template.content.cloneNode(true));
        this.querySelector('video')?.load();
      }
      const video = this.querySelector('video');
      if (!video) return;
      const generation = ++this.generation;
      try {
        await video.play();
        if (generation !== this.generation) { video.pause(); return; }
        this.state(true);
      } catch (_) { if (generation === this.generation) this.state(false); }
    }
    disconnectedCallback() {
      this.stop(); this.observer?.disconnect(); this.controller?.abort(); this.controller = null;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
